import { useTranslation } from 'react-i18next'

import { Plus } from '@phosphor-icons/react'

import { Button, Text } from '@reveni-io/reveni-ui'

import SortableList from '@/configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/SortableList/SortableList'
import SortableWrapper from '@/configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/SortableWrapper/SortableWrapper'

import SubReason from './SubReason/SubReason'
import * as Styles from './styles'

const SubReasonsSection = ({
  onAddSubReason,
  onDeleteSubReason,
  onEditSubReasonInternalName,
  onEditSubReasonDisplay,
  languages,
  subReasons,
  onSortEnd,
  onSortStart,
  dragging,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleS">{t('Submotivos')}</Text>
      <Text type="bodyMRegular">{t('Define los submotivos asociados a este motivo de devolución')}</Text>
      <SortableList items={subReasons || []} onSortEnd={onSortEnd} onSortStart={onSortStart}>
        <Styles.SubReasonContainer>
          {subReasons?.map(subReason => (
            <SortableWrapper key={subReason.id} id={subReason.id} dragging={dragging}>
              <SubReason
                info={subReason}
                onDelete={onDeleteSubReason}
                languages={languages}
                onEditSubReasonInternalName={onEditSubReasonInternalName}
                onEditSubReasonDisplay={onEditSubReasonDisplay}
              />
            </SortableWrapper>
          ))}
        </Styles.SubReasonContainer>
      </SortableList>
      <div>
        <Button variant="text" onClick={() => onAddSubReason(languages)}>
          <Plus />
          {t('Añadir submotivo')}
        </Button>
      </div>
    </Styles.Container>
  )
}

export default SubReasonsSection
